import cookie from 'webmd-cookie';
import debug from 'webmd-debug';
/*
* Transunion Connectivity api integration
*/

if (typeof window !== 'undefined') {

  window.webmd = window.webmd || {};
  let apikey = '2663973606';

  // Check if the cookie is older than 7 days
  function isCookieOlderThanSevenDays(cookieDate) {
    const currentDate = new Date();
    const cookieDateTime = new Date(cookieDate);
    const timeDiff = currentDate.getTime() - cookieDateTime.getTime();
    const daysDiff = timeDiff / (1000 * 3600 * 24);
    return daysDiff > 7;
  }

  // Set the default cookie
  function setDefaultCookie() {
    let expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 99);
    let cookieValue = {
      id: '0',
      timestamp: new Date().toUTCString()
    };
    cookie.set('truAudience_id', JSON.stringify(cookieValue), { expires: expirationDate.toUTCString() });
    //Set page targets for true Audience ID
    if (window.webmd.ads){
      window.webmd.ads.setPageTarget('tuid',0);
    }
  }

  // Fetch a new TrueAudience ID
  let fetchNewTrueAudienceID = async function() {
    const pageUrl = document.location.href || '';
    const apiUrl = `https://fid.agkn.com/f?apiKey=${apikey}`;
    const referrerUrl = document.referrer || '';
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 99);

    const body = {
        sae: { type: "web" },
        u: 'https://www.webmd.com',
        f: 'https://www.webmd.com'
    };

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            debug('Failed to fetch transunion data. Status:', response.status);
            return setDefaultCookie();
        }

        const responseData = await response.json();
        if (responseData && responseData.TruAudienceID) {
            const truAudience = responseData.TruAudienceID;
            const cookieValue = {
                id: truAudience,
                timestamp: new Date().toUTCString()
            };
            cookie.set('truAudience_id', JSON.stringify(cookieValue), { expires: expirationDate.toUTCString() });
            setUpOmniCall(truAudience);
            setPageTarget(truAudience);
        } else {
            setDefaultCookie();
        }
    } catch (error) {
        debug('Error fetching True Audience ID:', error);
        setDefaultCookie();
    }
  };

  const setUpOmniCall = (truAudience) => {
      document.addEventListener('onAdobeOmniBeforePv', () => {
          if (window && window.globalMetrics && typeof window.globalMetrics.setMetric === 'function') {
              window.globalMetrics.setMetric('identity.transunion', truAudience);
          } else if (window && window.s_md && window.s_md.contextData) {
              window.s_md.contextData['wb.transunion'] = truAudience;
          }
      }, { once: true });
  };

  const setPageTarget = (truAudience) => {
      if (window.webmd && window.webmd.ads) {
          window.webmd.ads.setPageTarget('tuid', truAudience);
      }
  };


  // Function to set TrueAudience ID
  let setTrueAudienceID = async function () {
    let truAudienceData = cookie.get('truAudience_id');

    try {
        truAudienceData = JSON.parse(truAudienceData);
    } catch (error) {
        await fetchNewTrueAudienceID();
        return;
    }

    if (!truAudienceData || !truAudienceData.id) {
        await fetchNewTrueAudienceID();
        return;
    }

    const isOldCookie = isCookieOlderThanSevenDays(truAudienceData.timestamp) || truAudienceData.id === '0';
    if (isOldCookie) {
        await fetchNewTrueAudienceID();
        return;
    }


    // Pass truAudience ID to the omniture call
    const webmdCcm = window.webmdCcm;
    const isCa = window.isCa;
    const optanonCookie = webmdCcm && webmdCcm.optanonCookie;
    const blockOmni = optanonCookie && isCa && Object.keys(optanonCookie).length > 0 && (optanonCookie.goBlock || !optanonCookie.advCookies);

    try {
      if(!blockOmni){
        setUpOmniCall(truAudienceData.id);
      }
    } catch (error) {
      debug('Error setting truAudience ID:', error);
    }

    //Set PageTarget for truAudience ID
    if(!blockOmni){
      setPageTarget(truAudienceData.id);
    }

  };


  /**
  * we need to load Transunion Connectivity API once __tcfapiPromise is resolved,
  * the Promise is resolved once tcfapi.js is loaded onto the page
  *
  * tcfapi.js is loaded only in EU locations and in other locations the Promise is
  * resolved immediately (handled in IAB stub code - webmd-ccm.js)
  */
  Promise.resolve(window.__tcfapiPromise).then(function () {
    //PPE-379353 : Disable Vendor
    //Disable vendor if url containts vendor=0 or nf=0
    var url = (document.referrer) ? document.referrer : document.location.href;
    if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('tu=0') > -1)) {
      return false;
    }

    // block vendor on sensitive pages
    if (window.s_sensitive && window.s_sensitive === "true") {
      return false;
    }

    //PPE-411484 don't execute on member pages
    // if we are on member or webmdrx page, return immediately
    if ((/member.|webmdrx\./).test(location.host)) {
      return;
    }
    // Disable vendor based on ads admin tool data
    if(window.globalConfig && window.globalConfig.ads) {

      let vendorConfig = window.globalConfig.ads.vendorConfig;
      let transunionConfig = vendorConfig.transUnion ? vendorConfig.transUnion : {};
      let location = cookie.getJson('gtinfo');
      
      /**
       *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
       *  hence text transform is done.
       */
      let isLocationAdded = false;
      let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
      let locationList = transunionConfig.location ? transunionConfig.location : [];
                                                                                                                                                                                                                                                                        
      /** 
       *  If the gtinfo is not available and only some of the locations are selelcted, 
       *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
       *  as default behavior. 
       * 
       *  If location property is undefined or no countries are added in location array 
       *  or all the countries are selected, then it can be considered as 
       *  all the locations are selected and not required to check for gtinfo.
       *  Countries available in WebMD gtinfo file : 249
       */
      if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
        if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
          isLocationAdded = true;
        }
        /**
         *  If disable is true and the location is included in the location array, 
         *  then vendor should not be loaded.   
         *  If disable is set to false and certain countries are added in location array, 
         *  then for the countries that are not added in the array can be considered 
         *  to have disable : true and vendor should not be loaded in this case. 
         */
        if (transunionConfig.disable && isLocationAdded) {
          return false;
        } else if ( !(transunionConfig.disable) && !isLocationAdded ) {
          return false;      
        }
      }
    }

    // Block on GDPR and CCPA
    if(window.webmdCcm && window.webmdCcm.optanonCookie) {
      let webmdCcm  = window.webmdCcm || {};
      webmdCcm.optanonCookie = window.webmdCcm.optanonCookie;

      if (window.countryBlocked && ((webmdCcm.optanonCookie.goBlock || webmdCcm.optanonCookie.noCookie) || !webmdCcm.optanonCookie.advCookies)){
        return false;
      } else if (window.isCa && Object.keys(webmdCcm.optanonCookie).length > 0 && (webmdCcm.optanonCookie.goBlock || !webmdCcm.optanonCookie.advCookies)) {
          return false;
      }
    }

    try {
      setTrueAudienceID();
    
    }
    catch(e) {
      debug(e)
    }

  });

};